import { render } from "./ContentTemplate.vue?vue&type=template&id=501e3a3e&scoped=true"
import script from "./ContentTemplate.vue?vue&type=script&lang=js"
export * from "./ContentTemplate.vue?vue&type=script&lang=js"

import "./ContentTemplate.vue?vue&type=style&index=0&id=501e3a3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501e3a3e"]])

export default __exports__